import { plural, t, Trans } from '@lingui/macro';

import Alert from '@decisiv/ui-components/lib/components/Alert';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { H3, P } from '@decisiv/ui-components/lib/components/Typography';

import { useBulkCreateDepotContext } from '../context/BulkCreateDepotContext';
import { CountsContainer } from './styles';

const Summary = () => {
  const { summary, failedToResolve } = useBulkCreateDepotContext();

  // Polling stopped without a resolved server outcome (repeated errors / timeout).
  // Don't render "0 added / 0 failed" — that reads as a completed no-op run.
  if (failedToResolve || !summary) {
    return (
      <Flex flexDirection="column">
        <H3>
          <Trans>Summary</Trans>
        </H3>
        <Flex marginTop={1}>
          <Alert intent="warning" title={t`Import status unavailable`}>
            <Trans>
              We couldn&apos;t confirm the result of your upload. It may still
              be processing — check the depots list in a few minutes before
              retrying.
            </Trans>
          </Alert>
        </Flex>
      </Flex>
    );
  }

  const added = summary.successful ?? 0;
  const failed = summary.failed ?? 0;

  return (
    <Flex flexDirection="column">
      <H3>
        <Trans>Summary</Trans>
      </H3>

      <CountsContainer>
        <P shade={1}>
          {plural(added, { one: '# depot added', other: '# depots added' })}
        </P>
        <P shade={1}>
          {plural(failed, { one: '# depot failed', other: '# depots failed' })}
        </P>
      </CountsContainer>
    </Flex>
  );
};

export default Summary;
